import Box from '@mui/material/Box';
import React from 'react';
import "./../../assets/scss/MarketingContent.scss";
import TabsComponent from './TabsComponent';
import NotificationsTab from './NotificationsTab';
import ModuleHeader from '../../components/ModuleHeader/ModuleHeader';
import { useSelector } from 'react-redux';
var MarketingContent = function () {
    var userBasicInfo = useSelector(function (store) { return store.User.userData; });
    var rolePermissions = (userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.RolePermissions) || [];
    var marketingPermission = rolePermissions.find(function (perm) { return perm.PermissionKey === 'MARKETING_CONTENT'; });
    var canView = (marketingPermission === null || marketingPermission === void 0 ? void 0 : marketingPermission.View) === 1;
    var canAdd = (marketingPermission === null || marketingPermission === void 0 ? void 0 : marketingPermission.Add) === 1;
    var canUpdate = (marketingPermission === null || marketingPermission === void 0 ? void 0 : marketingPermission.Update) === 1;
    var canDelete = (marketingPermission === null || marketingPermission === void 0 ? void 0 : marketingPermission.Delete) === 1;
    var _a = React.useState('1'), selectedTab = _a[0], setSelectedTab = _a[1];
    var tabs = [
        { label: "General Notification", value: '1', content: React.createElement("div", null,
                React.createElement(NotificationsTab, { selectedTab: selectedTab, canView: canView, canAdd: canAdd, canUpdate: canUpdate, canDelete: canDelete })) },
        { label: "Portal Notification", value: '2', content: React.createElement("div", null,
                React.createElement(NotificationsTab, { selectedTab: selectedTab, canView: canView, canAdd: canAdd, canUpdate: canUpdate, canDelete: canDelete })) },
    ];
    var handleTabChange = function (event, newValue) {
        setSelectedTab(newValue);
    };
    return (React.createElement(Box, { className: "common-module-wrapper marketing-main" },
        React.createElement(ModuleHeader, { moduleName: 'Marketing Content Configuration', placeHolderText: 'Search by TicketID', hasPortalDD: false, hasStatusDD: false, hasSearch: false, hasAddItem: false, getSelectedPortal: function () { }, selectedStatus: function () { }, getSearchedText: function () { }, isDrawerOpen: function () { }, sx: {
                position: "sticky",
                top: "55px",
                zIndex: 3,
            } }),
        React.createElement(Box, { className: "tabs-main" },
            React.createElement(Box, { className: "tabs" },
                React.createElement(TabsComponent, { tabs: tabs, selectedTab: selectedTab, onTabChange: handleTabChange })))));
};
export default MarketingContent;
